import { PAYMENT_MODE_LABEL } from '../components/TokenPrintModal';

/**
 * Presentation for visit (token) audit entries, shared by the Change History panel in the visit
 * details modal and the Token Edits report. Both read the same rows from visit_audit_logs, so they
 * must label fields and render values identically.
 */

export const AUDIT_FIELD_LABELS = {
  doctor: 'Doctor',
  medicalService: 'Service',
  discountAmount: 'Discount',
  finalFee: 'Final fee',
  paymentMode: 'Payment mode',
  isEmergency: 'Emergency',
  status: 'Status',
  tokenNumber: 'Token',
};

/** Friendly label for a stored field name, falling back to the raw name for anything new. */
export const auditFieldLabel = (field) => AUDIT_FIELD_LABELS[field] || field;

// Vitals amendments are written to the same log (action VITALS_EDITED) under the reading's own field
// name. Shared by the Vitals Edits report and the Patient Profile's token edits.
export const VITAL_FIELD_LABELS = {
  bpSystolic: 'BP Systolic',
  bpDiastolic: 'BP Diastolic',
  pulse: 'Pulse',
  temperature: 'Temperature',
  weight: 'Weight',
  height: 'Height',
  bloodSugar: 'Blood Sugar',
  spo2: 'SpO2',
  respiratoryRate: 'Respiratory Rate',
  lengthCm: 'Length',
  headCircumferenceCm: 'Head Circumference',
  muacCm: 'MUAC',
};

export const VITAL_FIELD_UNITS = {
  bpSystolic: 'mmHg', bpDiastolic: 'mmHg', pulse: 'bpm', temperature: 'F',
  weight: 'kg', height: 'cm', bloodSugar: 'mg/dL', spo2: '%',
  respiratoryRate: '/min', lengthCm: 'cm', headCircumferenceCm: 'cm', muacCm: 'cm',
};

export const vitalFieldLabel = (field) => VITAL_FIELD_LABELS[field] || field;

const MONEY_FIELDS = new Set(['discountAmount', 'finalFee']);

/**
 * Render a stored audit value the way the rest of the app shows that field, so the history reads
 * like the screens it describes rather than like raw column data. Values are stored as text, hence
 * the string comparisons.
 */
export const formatAuditValue = (value, fieldName) => {
  if (value === null || value === undefined || value === '') return '—';
  if (MONEY_FIELDS.has(fieldName)) return `₨${Number(value).toLocaleString()}`;
  if (fieldName === 'isEmergency') return value === 'true' ? 'Yes' : 'No';
  if (fieldName === 'paymentMode') return PAYMENT_MODE_LABEL[value] || value;
  if (fieldName === 'status') return String(value).replace(/_/g, ' ');
  return value;
};
